import React from 'react';

import { environments } from '@trqk/utils';
import { IconX, CodeBlock } from '@trqk/components';

export const EnvironmentsModal = ({
    remove,
}: ModalContentProps<Record<string, never>>): JSX.Element => (
    <div className="rounded-lg bg-white">
        <div className="flex justify-end w-full">
            <IconX
                addClasses="m-10"
                fillColor="tertiary-400"
                handleClick={() => {
                    remove({
                        canceled: false,
                        success: true,
                    });
                }}
                width={20}
            />
        </div>
        <div className="overflow-y-auto mx-10 mb-6" style={{ height: 600 }}>
            <CodeBlock
                code={environments.web}
                maxWidth={1400}
                showControls={false}
            />
        </div>
    </div>
);
